import React from 'react';
import SkeletonBone from './SkeletonBone';
import './loading.css';

const SkeletonGallery = ({ thumbs = 5 }) => (
  <div className="skeleton-details__gallery" aria-hidden="true">
    <SkeletonBone className="skeleton-details__hero" />
    <div className="skeleton-details__thumbs">
      {Array.from({ length: thumbs }, (_, index) => (
        <SkeletonBone key={index} className="skeleton-details__thumb" />
      ))}
    </div>
  </div>
);

export default SkeletonGallery;
